import * as actions from './actions';

const initialState = {
  orders: [],
  totalCount: 0,
  loading: false,
  error: null,
  updating: false,
  updateError: null,
};

export default function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_ORDERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_ORDERS.SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.data.results || [],
        totalCount: action.payload.data.count || 0,
        error: null,
      };
    case actions.FETCH_ORDERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case actions.UPDATE_ORDER_STATUS.REQUEST:
      return {
        ...state,
        updating: true,
        updateError: null,
      };
    case actions.UPDATE_ORDER_STATUS.SUCCESS:
      // Update the order in the list
      return {
        ...state,
        updating: false,
        orders: state.orders.map((order) =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        updateError: null,
      };
    case actions.UPDATE_ORDER_STATUS.FAILURE:
      return {
        ...state,
        updating: false,
        updateError: action.payload,
      };

    default:
      return state;
  }
}
